import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const consent = localStorage.getItem('cookie_consent')
    if (!consent) {
      this.element.classList.remove('hidden')
    }
  }

  accept() {
    localStorage.setItem('cookie_consent', 'accepted')
    localStorage.setItem('cookie_consent_date', new Date().toISOString())
    this.hide()
  }

  decline() {
    localStorage.setItem('cookie_consent', 'declined')
    localStorage.setItem('cookie_consent_date', new Date().toISOString())
    this.hide()
  }

  hide() {
    this.element.classList.add('hidden')
  }
}
